//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import React, { ReactElement } from 'react'
import LenderInvestmentListSummary from './LenderInvestmentListSummary'

export default function LenderPortfolioPage(): ReactElement {
  return <LenderInvestmentListSummary />
}
